import { render, staticRenderFns } from "./NewPendingInvoice.vue?vue&type=template&id=90a0e0dc&scoped=true&"
import script from "./NewPendingInvoice.vue?vue&type=script&lang=js&"
export * from "./NewPendingInvoice.vue?vue&type=script&lang=js&"
import style0 from "./NewPendingInvoice.vue?vue&type=style&index=0&id=90a0e0dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a0e0dc",
  null
  
)

export default component.exports